import { getActiveFilterStates } from 'tradera/apps/tradera/components/discover/helpers/filter-states';

const normalizeFilters = (filters) => {
    if (filters) {
        const normalized = filters.reduce((aggregated, filter) => {
            return {
                ...aggregated,
                [filter.parameter]: {
                    ...filter
                }
            };
        }, {});
        return normalized;
    }
};

const activeFilters = (filters, shippingRegionCountryCodeIso2) => {
    if (filters) {
        const normalized = [];
        filters.map((filter) => {
            const { selectedValue } = filter;
            if (
                getActiveFilterStates(shippingRegionCountryCodeIso2).includes(
                    selectedValue
                )
            ) {
                normalized.push(filter);
            }
        });
        return normalized;
    }
};

// This prevents a huge SSR HTML payload in categories with many attributes, such as brands
// For brands it decreases the __NEXT_DATA__ payload from ~100 kB to ~20 kB
const compressAttributeFilterOptions = (attributeFilter) =>
    attributeFilter.map((attributeFilter) => [
        attributeFilter.value,
        attributeFilter.sortOrder
    ]);

const compressAttributeFilters = (attributeFilters) => {
    if (!attributeFilters) return;

    return attributeFilters.map((attributeFilter) => ({
        ...attributeFilter,
        options: compressAttributeFilterOptions(attributeFilter.options) || null
    }));
};

const normalize = (responseData, shippingRegionCountryCodeIso2 = 'se') => {
    const normalized = {
        activeBrands: [],
        activeFilters: [],
        attributeFilters: [],
        categoryPath: responseData.categoryPath || [],
        currentCategoryId: responseData.categoryPath?.[0]?.id || 0,
        filterCategories: {},
        filterPrice: {},
        filters: {},
        headerText: responseData.headerText || null,
        internalSearch: responseData.internalSearchBar || {},
        introText: responseData.introText || null,
        isSavedSearchEmailEnabled:
            responseData?.isSavedSearchEmailEnabled || false,
        isShopOwnedByCurrentMember:
            responseData?.itemsOnDisplay?.isShopOwnedByCurrentMember || false,
        items: [],
        itemsOnDisplay: [],
        mainText: responseData.mainText || null,
        pagination: responseData.pagination || null,
        totalItems: responseData.totalItems || 0,
        reduxContainer: responseData.reduxContainer || {},
        searchLanguages: responseData.searchLanguages || []
    };

    if (responseData.filters) {
        const {
            categoryFilter,
            singleOptionFilters,
            priceRangeFilter,
            attributeFilters
        } = responseData.filters;

        normalized.filterCategories = categoryFilter;
        normalized.filters = normalizeFilters(singleOptionFilters);
        normalized.activeFilters = activeFilters(
            singleOptionFilters,
            shippingRegionCountryCodeIso2
        );
        normalized.filterPrice = priceRangeFilter;

        // responseData.filters.attributeFilters does not exist in response from
        // [touchwebUrl]/campaign/sista-chansen.json?sortBy=TimeLeft
        // and undefined properties is not allowed in NextWeb
        if (attributeFilters) {
            normalized.attributeFilters =
                compressAttributeFilters(attributeFilters);
        }
    }

    if (responseData.items) {
        normalized.items.push(...responseData.items);
    }

    if (responseData.itemsOnDisplay) {
        normalized.itemsOnDisplay.push(...responseData.itemsOnDisplay.items);
    }

    return normalized;
};

export { normalize };
